import {Component, AfterViewInit, OnInit} from '@angular/core';
import {ROUTES} from './menu-items';
import {RouteInfo} from './sidebar.metadata';
import {Router, ActivatedRoute} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../services/auth.service';
import {UserService} from '../../services/user.service';
import { ConnectionService } from 'ng-connection-service';

import * as firebase from 'firebase';

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  public sidebarnavItems: any[];
  public user: any;
  public profile;

  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }

  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  status = 'ONLINE';
  isConnected = true;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private connectionService: ConnectionService,
    private route: ActivatedRoute,
    private userService: UserService,
    private authService: AuthService,
  ) {


    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = 'ONLINE';
      } else {
        this.status = 'OFFLINE';
      }
    });

  }

  ngOnInit() {
    this.profile = this.authService.profile;
    if (this.profile !== -1) {
      this.user = this.authService.user;
      if (this.profile === 20) {

        ROUTES[0].path = '/dashboard/dashboardoperationpublic';
      }
      this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem.profile === this.profile);

    } else {
      firebase.auth().onAuthStateChanged(
        async (user: firebase.User) => {
          if (user) {
            await this.getUser(user);
          } else {
          }
        }
      );
    }
  }


  getUser(user: any) {
    this.userService.getSingleUser(user.uid)
      .then(
        (utilisateur: any) => {
          // console.log('user', utilisateur);
          this.user = utilisateur;
          this.profile = utilisateur.profil;
          if (this.profile === 20) {
            ROUTES[0].path = '/dashboard/dashboardoperationpublic';
          }
          this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem.profile === this.profile);
        },
        (erred) => {
        }
      )
      .catch(
        (error) => {
        }
      );
  }
}
